import React, {useRef, useState, useEffect} from 'react'
import Button from './Button'
interface ButtonProps {
  data: any[]
  loading?: boolean
  disabled?: boolean
}

const DowloadReport = ({loading = false, data, disabled = false, ...props}: ButtonProps) => {
  const refWrapperDownload = useRef<HTMLDivElement | null>(null)
  const [isOpenDownloadMenu, setIsOpenDownloadMenu] = useState<boolean>(false)

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (refWrapperDownload.current && !refWrapperDownload.current.contains(event.target)) {
        setIsOpenDownloadMenu(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])
  const handleToggleOpenMenu = () => {
    setIsOpenDownloadMenu(!isOpenDownloadMenu)
  }

  return (
    <div className='position-relative' ref={refWrapperDownload}>
      <Button
        label='Descargar Reporte'
        disabled={loading}
        loading={loading}
        classNameProp='px-5'
        onClick={handleToggleOpenMenu}
        typeIcon='download'
      />
      <div
        className='menu bg-white position-absolute end-0 z-index-3 border mt-1 menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4'
        style={{display: isOpenDownloadMenu ? 'block' : 'none'}}
      >
        {data.map((item) => {
          return (
            <div className='menu-item px-3'>
              <div
                role='button'
                className='menu-link px-3'
                onClick={() => {
                  setIsOpenDownloadMenu(false)
                  item.report()
                }}
              >
                {item.text}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default DowloadReport
